export default __webpack_public_path__ + "static/media/celebrate1.8ac3409d.gif";